// extracted by mini-css-extract-plugin
export default {"information":"Information_information__PE+qa","content":"Information_content__mPRce","text":"Information_text__Z8LZK","image":"Information_image__p7DHn"};